<template>
  <div>
    <svg
      ref="waveSvg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
      class="animated-wave"
    >
      <defs>
        <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#a4b1b9" />
          <stop offset="100%" stop-color="#fff" />
        </linearGradient>
      </defs>
      <path
        ref="wavePathStroke"
        class="wave-path-stroke"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      />
      <path
        ref="wavePathFill"
        class="wave-path-fill"
        fill="url(#waveGradient)"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      />
    </svg>

    <div class="rompecabezas-container" ref="containerRef">
      <div class="v-stack-container">
        <img
          v-for="(foto, index) in fotos"
          :key="index"
          :ref="el => (fotoRefs[index] = el)"
          :src="foto"
          :alt="`Foto ${index + 1}`"
          :class="['foto-individual', index % 2 === 0 ? 'tilt-left' : 'tilt-right']"
          @click="abrirModal(foto)"
        />
      </div>
    </div>

    <div v-if="fotoModal" class="modal" @click="cerrarModal">
      <img :src="fotoModal" class="modal-img" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'RompecabezasFotos',
  setup() {
    const containerRef = ref(null);
    const waveSvg = ref(null);
    const wavePathStroke = ref(null);
    const wavePathFill = ref(null);
    const fotoModal = ref(null);

    // Solo 2 fotos como solicitaste
    const fotos = [
      require('@/assets/10.png'),

    ];

    const fotoRefs = ref([]);

    const abrirModal = (foto) => {
      fotoModal.value = foto;
    };

    const cerrarModal = () => {
      fotoModal.value = null;
    };

    const animate = () => {
      const pathLength = wavePathStroke.value.getTotalLength();
      wavePathStroke.value.style.strokeDasharray = pathLength;
      wavePathStroke.value.style.strokeDashoffset = pathLength;

      const tl = gsap.timeline();

      // Animación de la Ola
      tl.fromTo(waveSvg.value, { opacity: 0, y: -60 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out' })
        .to(wavePathStroke.value, { strokeDashoffset: 0, duration: 1.2, ease: 'power2.inOut' }, '-=0.7')
        .to(wavePathFill.value, { opacity: 1, duration: 1, ease: 'power1.inOut' }, '-=1');

      // Animación de las 2 fotos (Consecutiva)
      fotoRefs.value.forEach((el, i) => {
        const fromX = i % 2 === 0 ? -150 : 150; // Una de la izq, otra de la der
        const rotateStart = i % 2 === 0 ? -15 : 15; // Inclinación inicial

        tl.fromTo(
          el,
          { 
            x: fromX, 
            opacity: 0, 
            scale: 0.8, 
            rotate: rotateStart,
            filter: 'blur(10px)'
          },
          {
            x: 0,
            opacity: 1,
            scale: 1,
            rotate: i % 2 === 0 ? -3 : 3, // Inclinación final elegante
            filter: 'blur(0px)',
            duration: 1.4,
            ease: 'expo.out'
          },
          `-=${i === 0 ? 0.8 : 1.1}` // La segunda empieza casi enseguida
        );
      });
    };

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate();
          obs.unobserve(entry.target);
        }
      }, { threshold: 0.2 });

      if (containerRef.value) observer.observe(containerRef.value);
    });

    return {
      containerRef,
      waveSvg,
      wavePathStroke,
      wavePathFill,
      fotos,
      fotoRefs,
      fotoModal,
      abrirModal,
      cerrarModal,
    };
  },
};
</script>

<style scoped>
.rompecabezas-container {
  position: relative;
  width: 100%;
  padding: 40px 0 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background: transparent;
}

.animated-wave {
  width: 100%;
  height: auto;
  pointer-events: none;
  opacity: 0;
}

.wave-path-stroke {
  fill: none;
  stroke: #ffffff;
  stroke-width: 3;
}

.wave-path-fill {
  opacity: 0;
}

.v-stack-container {
  display: flex;
  flex-direction: column;
  gap: 40px; /* Espacio entre las fotos */
  width: 85%;
  max-width: 450px;
  margin-top: -20px;
}

.foto-individual {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  border: 6px solid #ffffff; /* Marco elegante tipo Polaroid moderna */
  opacity: 0;
  cursor: pointer;
  will-change: transform, opacity;
}

/* Inclinaciones para dar estilo de "fotos pegadas" */
.tilt-left { transform: rotate(-3deg); }
.tilt-right { transform: rotate(3deg); }

.foto-individual:hover {
  transform: scale(1.02) rotate(0deg) !important;
  z-index: 10;
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* MODAL */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-img {
  max-width: 100%;
  max-height: 85vh;
  border-radius: 10px;
  object-fit: contain;
  box-shadow: 0 0 40px rgba(0,0,0,0.5);
}

@media (max-width: 480px) {
  .v-stack-container {
    width: 90%;
    gap: 30px;
  }
}
</style>